import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { hasFeature } from '@precert/has-feature';
import noop from 'lodash/noop';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

import { AutoFocusHeader } from '../../../_components/auto-focus-header';
import { useConfig } from '../../../_components/config';
import { StartOverButton } from '../../../_components/start-over-button';

import styles from './styles.module.scss';

export function SessionAvailable({ onNext = noop }) {
  const { features } = useConfig();
  const navigate = useNavigate();
  const message =
    'You currently have an active session in this browser. ' +
    'You can start filling out the form immediately by clicking on "Start".';

  return (
    <div className="d-flex justify-content-center my-5">
      <Card className={`${styles.card} shadow-sm`}>
        <CardBody>
          <div className="text-center">
            <AutoFocusHeader>No Email Required</AutoFocusHeader>
            <p className="text-large mt-5">{message}</p>
            <p className="my-5">
              <FontAwesomeIcon
                icon={faCheckCircle}
                size="8x"
                color="#008817"
                className="d-inline-block"
              />
            </p>
            <div>
              <StartOverButton
                label="Start"
                onClick={() =>
                  hasFeature('update-precert', features)
                    ? navigate('/home')
                    : onNext()
                }
                className="px-4 mb-1"
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
